var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardListSection',_vm._b({staticClass:"c-block-list-related-content",attrs:{"id":("block-" + (_vm.$vnode.key))}},'CardListSection',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }